import React from 'react';
import { QuestionnaireItem } from '../QuestionnairePreview';
// @ts-ignore
import styles from './../QuestionnairePreview.module.scss';
import { QuestionnaireItemSubtype } from '../../../Enums/QuestionnaireItemSubtype.enum';

interface Props {
	item: QuestionnaireItem;
}

const QuestionnairePreviewText: React.FC<Props> = ({ item }) => {
	let component;

	switch (item.subtype) {
		case QuestionnaireItemSubtype.FRAMED:
			component = <div className={styles.textFramed}>{item.value}</div>;
			break;
		case QuestionnaireItemSubtype.SUBTITLE:
			component = <div className={styles.textSubtitle}>{item.value}</div>;
			break;
		case QuestionnaireItemSubtype.LIST_ITEM:
			component = <div className={styles.textListItem}>{item.value}</div>;
			break;
		default:
			component = <div className={styles.text}>{item.value}</div>;
			break;
	}

	return <div className={styles.item}>{component}</div>;
};

export default QuestionnairePreviewText;
